import { render, staticRenderFns } from "./DropDownComponentsBox.vue?vue&type=template&id=30c2bd20"
import script from "./DropDownComponentsBox.vue?vue&type=script&lang=js"
export * from "./DropDownComponentsBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports